module.exports = __webpack_public_path__ + "static/media/8.f1a8fd18.jpg";